<div
  class="widget-title-container"
  [ngClass]="{ smallScreen: isSmallScreen, focus: sortPopupActive || contextMenuOpened, ' widget-handler': allowWidgetHandler , 'un-moved-widget': !movedWidget }"
>
  <u-icon *ngIf="movedWidget" class="dragging-icon" [model]="{ type: 'font', value: 'icon-dragging-ind' }" [styles]="{ fontSize: '12px' }">
  </u-icon>
  <ng-content></ng-content>
  <h1 class="title" *ngIf="title" (click)="navigate.emit()">{{ title }}</h1>
  <div class="action" #actions>
    <u-button
      *ngIf="sectionButtons?.seeAll"
      class="title-button no-state"
      label="See all"
      type="secondary"
      [styles]="{ width: '80px' }"
      (onClick)="navigate.emit()"
      [attr.data-cy]="'see-all-' + navigateUrl"
    ></u-button>
    <u-button
      *ngIf="sectionButtons?.sort"
      #sortButtonRef
      class="sort-icon"
      elementSize="small"
      fontIcon="sort-list-down"
      type="secondary"
      [class.sort-active]="sortPopupActive"
      [styles]="{ border: 'unset', height: '24px', width: '24px' }"
      (onClick)="openSort(sortButtonRef)"
    ></u-button>
    <square-button
      *ngIf="sectionButtons?.contextMenu"
      [active]="contextMenuOpened"
      class="square-button"
      (click)="$event.stopPropagation(); openContextMenu.emit($event)"
      (auxclick)="$event.stopPropagation(); openContextMenu.emit($event)"
      (contextmenu)="$event.stopPropagation(); openContextMenu.emit($event)"
      #actions
      >•••</square-button
    >
  </div>
</div>
